






























import { createComponent } from "@vue/composition-api";
import { DecisionState } from "@megarax/client/src/resources/Decision";

interface Props {
  value: DecisionState;
}

export default createComponent<Props>({
  components: {},
  props: {
    value: { required: true },
  },
  setup(props, ctx) {
    return { DecisionState };
  },
});
